document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-np-product]');
  if (!root) return;

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  // Labels Shopify exacts (Option 1 = Couleur) + label marketing affiché.
  const COLORS = [
    { shopify: 'Bleu',   label: 'Glacier Blue', hex: '#09aeea' },
    { shopify: 'Rose',   label: 'Neon Pink',   hex: '#ef2b86' },
    { shopify: 'Vert',   label: 'Neon Green',   hex: '#66df12' },
    { shopify: 'Blanc',  label: 'Arctic White', hex: '#f4f4f4' },
    { shopify: 'Orange', label: 'Sunset Orange', hex: '#ff6415' }
  ];
  const SIZES = ['S', 'M', 'L', 'XL', '2XL', '3XL'];
  const PACK_PRICES = { 1: 8990, 2: 15990, 3: 22990 };
  const PACK_COMPARE = { 1: 8990, 2: 17980, 3: 26970 };
  let selectedPack = 1;
  let variants = [];
  try { variants = JSON.parse($('[data-np-variants-json]')?.textContent || '[]'); } catch (e) {}
  const base = variants.find(v => v.available) || variants[0] || { id: null, price: 8990, options: ['Bleu', 'M'] };

  const normalize = s => String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/g, '');

  // IMPORTANT: Shopify can localize option values (Bleu -> Blau, Vert -> Grün, etc.).
  // The visual swatches keep our canonical French keys, so resolve them by the
  // stable option-value ORDER coming from Shopify instead of comparing translated text.
  const localizedColorValues = [];
  variants.forEach(v => {
    const value = String(v.option1 ?? v.options?.[0] ?? '');
    if (value && !localizedColorValues.some(x => normalize(x) === normalize(value))) localizedColorValues.push(value);
  });
  const localizedSizeValues = [];
  variants.forEach(v => {
    const value = String(v.option2 ?? v.options?.[1] ?? '');
    if (value && !localizedSizeValues.some(x => normalize(x) === normalize(value))) localizedSizeValues.push(value);
  });

  const actualColorValue = canonicalColor => {
    const index = COLORS.findIndex(c => normalize(c.shopify) === normalize(canonicalColor));
    return index >= 0 ? (localizedColorValues[index] || canonicalColor) : canonicalColor;
  };
  const actualSizeValue = canonicalSize => {
    const key = normalize(canonicalSize);
    const aliases = {
      '2xl': ['2xl', 'xxl'],
      '3xl': ['3xl', 'xxxl']
    };
    const accepted = aliases[key] || [key];
    const direct = localizedSizeValues.find(v => accepted.includes(normalize(v)));
    return direct || canonicalSize;
  };

  const path = location.pathname.toLowerCase();
  const lang = path.startsWith('/de-de') || document.documentElement.lang?.toLowerCase().startsWith('de') ? 'de'
    : path.startsWith('/en-us') || document.documentElement.lang?.toLowerCase().startsWith('en') ? 'en' : 'fr';
  const sizeWord = lang === 'de' ? 'Größe' : lang === 'en' ? 'Size' : 'Taille';
  const moneyLocale = lang === 'de' ? 'de-DE' : lang === 'en' ? 'en-US' : 'fr-FR';
  const marketCurrency = document.documentElement.dataset.currency || (path.startsWith('/en-us') ? 'USD' : 'EUR');
  const money = cents => new Intl.NumberFormat(moneyLocale, { style: 'currency', currency: marketCurrency }).format((Number(cents) || 0) / 100);

  function variantFor(color, size, availableOnly = false) {
    if (!variants.length) return null;
    const wantedColor = normalize(actualColorValue(color));
    const wantedSize = normalize(actualSizeValue(size));
    return variants.find(v => {
      const colorOK = normalize(v.option1 || v.options?.[0]) === wantedColor;
      const sizeOK = normalize(v.option2 || v.options?.[1]) === wantedSize;
      return colorOK && sizeOK && (!availableOnly || v.available);
    }) || null;
  }

  function colorMeta(shopifyName) {
    return COLORS.find(c => normalize(c.shopify) === normalize(shopifyName)) || COLORS[0];
  }

  function rowSelection(row) {
    return {
      color: $('.np-mini-swatch.is-active', row)?.dataset.rowColor || COLORS[0].shopify,
      size: $('[data-row-size-select]', row)?.value || 'M'
    };
  }

  function syncRowAvailability(row) {
    if (!row) return;
    const { color, size } = rowSelection(row);
    $$('.np-mini-swatch', row).forEach(btn => {
      const exists = !!variantFor(btn.dataset.rowColor, size, false);
      // Shopify Markets can expose stale/market-scoped `available` flags after a
      // localization switch. Keep every real variant selectable here; the cart
      // endpoint remains the source of truth when the pack is submitted.
      btn.disabled = !exists;
      btn.classList.toggle('is-sold-out', !exists);
      btn.setAttribute('aria-disabled', String(!exists));
    });
    const select = $('[data-row-size-select]', row);
    if (select) {
      [...select.options].forEach(opt => {
        const exists = !!variantFor(color, opt.value, false);
        opt.disabled = !exists;
        opt.textContent = `${sizeWord} ${opt.value}`;
      });
    }
    row.classList.toggle('has-unavailable-selection', !variantFor(color, size, false));
  }


  function rowHTML(pack, index) {
    const label = pack === 1 ? 'Votre veste' : `Veste ${index + 1}`;
    return `<div class="np-pack-line" data-pack="${pack}" data-index="${index}">
      <span class="np-line-name">${label}</span>
      <div class="np-line-colors" aria-label="Couleur veste ${index + 1}">
        ${COLORS.map((c, i) => `<button type="button" class="np-mini-swatch ${i === 0 ? 'is-active' : ''} ${c.shopify === 'Blanc' ? 'is-white' : ''}" data-row-color="${c.shopify}" data-color-label="${c.label}" style="--sw:${c.hex}" aria-label="${c.label}" title="${c.label}"><span class="visually-hidden">${c.label}</span></button>`).join('')}
      </div>
      <label class="np-size-select-wrap">
        <span class="visually-hidden">${sizeWord} ${index + 1}</span>
        <select class="np-size-select" data-row-size-select aria-label="${sizeWord} ${index + 1}">
          ${SIZES.map(size => `<option value="${size}" ${size === 'M' ? 'selected' : ''}>${sizeWord} ${size}</option>`).join('')}
        </select>
      </label>
    </div>`;
  }

  function renderAllPacks() {
    [1, 2, 3].forEach(pack => {
      const box = $(`[data-pack-lines="${pack}"]`);
      if (box && !box.children.length) { box.innerHTML = Array.from({ length: pack }, (_, i) => rowHTML(pack, i)).join(''); $$('.np-pack-line', box).forEach(syncRowAvailability); }
    });
  }

  function unitPriceForActivePack() {
    const card = $(`[data-pack-card="${selectedPack}"]`);
    const first = $('.np-pack-line', card);
    const color = $('.np-mini-swatch.is-active', first)?.dataset.rowColor || COLORS[0].shopify;
    const size = $('[data-row-size-select]', first)?.value || 'M';
    return Number((variantFor(color, size, false) || base).price || 9990);
  }

  function updatePrices() {
    const unit = unitPriceForActivePack();
    const unitEl = $('[data-np-unit-price]');
    if (unitEl) unitEl.textContent = money(unit);
    [1, 2, 3].forEach(n => {
      const price = PACK_PRICES[n];
      const el = $(`[data-bundle-price="${n}"]`);
      const compare = $(`[data-bundle-compare="${n}"]`);
      if (el) el.textContent = money(price);
      if (compare) compare.textContent = money(PACK_COMPARE[n]);
    });
    const total = $('[data-np-total]');
    if (total) total.textContent = money(PACK_PRICES[selectedPack]);
  }

  $$('[data-np-thumb]').forEach(btn => btn.addEventListener('click', () => {
    const img = $('[data-np-main-image]');
    if (img) img.src = btn.dataset.src;
    $$('[data-np-thumb]').forEach(x => x.classList.remove('is-active'));
    btn.classList.add('is-active');
  }));

  // Swipe directly on the main image on touch devices.
  const mainMedia = $('.np-main-media');
  let swipeStartX = 0, swipeStartY = 0;
  const activateGalleryIndex = (index) => {
    const thumbs = $$('[data-np-thumb]');
    if (!thumbs.length) return;
    const safe = (index + thumbs.length) % thumbs.length;
    const btn = thumbs[safe];
    const img = $('[data-np-main-image]');
    if (img) img.src = btn.dataset.src;
    thumbs.forEach(x => x.classList.remove('is-active'));
    btn.classList.add('is-active');
    btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  };
  mainMedia?.addEventListener('touchstart', e => {
    const t = e.changedTouches[0]; swipeStartX = t.clientX; swipeStartY = t.clientY;
  }, { passive: true });
  mainMedia?.addEventListener('touchend', e => {
    const t = e.changedTouches[0];
    const dx = t.clientX - swipeStartX, dy = t.clientY - swipeStartY;
    if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.15) return;
    const thumbs = $$('[data-np-thumb]');
    const current = Math.max(0, thumbs.findIndex(x => x.classList.contains('is-active')));
    activateGalleryIndex(current + (dx < 0 ? 1 : -1));
  }, { passive: true });

  renderAllPacks();
  $$('.np-bundle-card').forEach(card => card.setAttribute('aria-expanded', card.classList.contains('is-active') ? 'true' : 'false'));

  $('.np-bundle-options')?.addEventListener('click', event => {
    const color = event.target.closest('[data-row-color]');
    const card = event.target.closest('[data-pack-card]');
    if (color) {
      event.preventDefault(); event.stopPropagation();
      const row = color.closest('.np-pack-line');
      $$('.np-mini-swatch', row).forEach(x => x.classList.remove('is-active'));
      color.classList.add('is-active');
      syncRowAvailability(row);
      if (Number(card?.dataset.packCard) !== selectedPack) card?.querySelector('input[name="np-bundle"]')?.click();
      updatePrices();
    }
  });

  $('.np-bundle-options')?.addEventListener('change', event => {
    const select = event.target.closest('[data-row-size-select]');
    if (!select) return;
    syncRowAvailability(select.closest('.np-pack-line'));
    const card = select.closest('[data-pack-card]');
    if (Number(card?.dataset.packCard) !== selectedPack) card?.querySelector('input[name="np-bundle"]')?.click();
    updatePrices();
  });

  $$('input[name="np-bundle"]').forEach(radio => radio.addEventListener('change', () => {
    selectedPack = Number(radio.value);
    $$('.np-bundle-card').forEach(card => { const active = Number(card.dataset.packCard) === selectedPack; card.classList.toggle('is-active', active); card.setAttribute('aria-expanded', active ? 'true' : 'false'); });
    updatePrices();
  }));

  const modal = $('[data-np-size-modal]');
  $('[data-np-size-guide]')?.addEventListener('click', () => { modal?.classList.add('is-open'); modal?.setAttribute('aria-hidden', 'false'); });
  $('[data-np-size-close]')?.addEventListener('click', () => { modal?.classList.remove('is-open'); modal?.setAttribute('aria-hidden', 'true'); });
  modal?.addEventListener('click', e => { if (e.target === modal) { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); } });

  $('[data-np-add]')?.addEventListener('click', async () => {
    const btn = $('[data-np-add]');
    const status = $('[data-np-status]');
    const activeCard = $(`[data-pack-card="${selectedPack}"]`);
    const rows = $$('.np-pack-line', activeCard);
    const items = rows.map((row, index) => {
      const color = $('.np-mini-swatch.is-active', row)?.dataset.rowColor || COLORS[0].shopify;
      const size = $('[data-row-size-select]', row)?.value || 'M';
      const v = variantFor(color, size, false);
      const meta = colorMeta(color);
      return v?.id ? { id: v.id, quantity: 1, properties: { 'Pack Glacier Shift': `${selectedPack} veste${selectedPack > 1 ? 's' : ''}`, 'Veste du pack': `${index + 1}/${selectedPack}`, 'Couleur choisie': meta.label, 'Taille choisie': size } } : null;
    }).filter(Boolean);

    if (items.length !== selectedPack) {
      status.textContent = 'Une couleur ou une taille sélectionnée est actuellement indisponible.';
      return;
    }
    try {
      btn.classList.add('is-loading'); btn.disabled = true; status.textContent = 'Ajout du pack…';
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!res.ok) throw new Error(await res.text());
      status.textContent = 'Pack ajouté au panier ✓';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(() => document.querySelector('[data-ma-cart-open]')?.click(), 220);
    } catch (e) {
      console.error('[Glacier Shift bundle]', e); status.textContent = 'Une combinaison choisie n’est pas disponible.';
    } finally { btn.classList.remove('is-loading'); btn.disabled = false; }
  });

  updatePrices();
});
